<div class="view-asset-page-footer">
  <!-- Favorite -->
  <button
    appButton
    name="toggle-like"
    location="asset-page-footer"
    color="dark-blur"
    height="1"
    size="1"
    weight="bold"
    [appTooltip]="'favorite' | translate"
    tooltipKeyboardShortcut="F"
    data-test-id="favorite"
    class="favorited-button"
    [class.favorited]="asset['is_liked']"
    *ngIf="display.favourite"
    [hasIcon]="display.favourite === 'full' || asset.likes > 0"
    (click)="toggleLike()"
    [iconButton]="display.favourite === 'small' && asset.likes === 0"
  >
    <app-svg src="/assets/icons/heart-empty.svg" *ngIf="!asset['is_liked']"></app-svg>
    <app-svg src="/assets/icons/heart-filled.svg" *ngIf="asset['is_liked']"></app-svg>
    <span *ngIf="asset.likes === 0 && display.favourite === 'full'">{{ 'favorite' | translate }}</span>
    <span *ngIf="asset.likes > 0 && display.favourite === 'full'"
      >{{ 'favorite' | translate }} ({{ asset.likes }})</span
    >
    <span *ngIf="asset.likes > 0 && display.favourite === 'small'">{{ asset.likes }}</span>
  </button>

  <!-- Flag -->
  <div class="button-group" *ngIf="display.flag">
    <button
      appButton
      name="toggle-approve"
      location="asset-page-footer"
      [color]="asset.status === 'approved' ? 'primary' : 'dark-blur'"
      [appTooltip]="'approve' | translate"
      tooltipKeyboardShortcut="D"
      height="1"
      size="1"
      weight="bold"
      [iconButton]="display.flag === 'small'"
      [hasIcon]="display.flag === 'full'"
      class="approved-button"
      [class.approved]="asset.status === 'approved'"
      data-test-id="approve"
      (click)="updateAssetStatus(asset.status === 'approved' ? 'no_status' : 'approved')"
    >
      <app-svg src="/assets/icons/flag-check.svg"></app-svg>
      <ng-container *ngIf="display.flag === 'full'">
        <span *ngIf="asset.status !== 'approved'">{{ 'approve' | translate }}</span>
        <span *ngIf="asset.status === 'approved'" class="approved-parent">
          {{ 'approved' | translate }}
          <div class="approval-limit" *ngIf="approvalLimit">
            {{ totalApproved }} {{ 'of' | translate }} {{ approvalLimit }}
          </div>
        </span>
      </ng-container>
    </button>
    <button
      appButton
      name="toggle-reject"
      location="asset-page-footer"
      [color]="asset.status === 'rejected' ? 'warn' : 'dark-blur'"
      [appTooltip]="'reject' | translate"
      tooltipKeyboardShortcut="X"
      height="1"
      spacing="1"
      data-test-id="reject"
      (click)="updateAssetStatus(asset.status === 'rejected' ? 'no_status' : 'rejected')"
    >
      <app-svg src="/assets/icons/flag-cross-outline.svg"></app-svg>
    </button>
  </div>

  <!-- Color label -->
  <app-context-menu
    [options]="{ width: '240px', noSpacing: true }"
    #menu
    name="asset-color-label"
    *ngIf="display.color_label"
  >
    <button
      appButton
      name="color-labels-dropdown"
      location="asset-page-footer"
      [hasIcon]="true"
      [color]="currentLabel?.color || 'dark-blur'"
      [appTooltip]="'add-label-tooltip' | translate"
      height="1"
      size="1"
      weight="bold"
      contextButton
      data-test-id="color_label"
      [class.double-icon]="display.color_label === 'small'"
    >
      <app-svg *ngIf="currentLabel" [src]="'/assets/icons/tags.svg'"></app-svg>
      <app-svg *ngIf="!currentLabel" [src]="'/assets/icons/tag-filled.svg'"></app-svg>
      <ng-container *ngIf="display.color_label === 'full'">
        <span *ngIf="!currentLabel">{{ 'add-label-button' | translate }}</span>
        <span *ngIf="currentLabel">{{ currentLabel.name | translateLabel }}</span>
      </ng-container>
      <app-svg src="/assets/icons/24/arrow-down.svg" size="-0-5"></app-svg>
    </button>
    <div contextContent>
      <div class="button-menu">
        <ng-container *ngFor="let label of colorLabels">
          <app-button-menu-item
            name="color-label-{{ label.color }}"
            location="asset-page-footer"
            (click)="updateColorLabel(label.color); menu.close()"
            icon="tag-filled"
            [iconColor]="label.color"
            [weight]="label.color === asset.color_label ? 'bold' : ''"
            [fullWidth]="true"
            *ngIf="label.active"
            [attr.data-test-id]="'color_label_' + label.color"
          >
            <span class="{{ label.color === asset.color_label ? 'text-color-' + label.color : '' }}">{{
              label.name | translateLabel
            }}</span>
          </app-button-menu-item>
        </ng-container>
        <app-button-menu-item
          name="color-label-null"
          location="asset-page-footer"
          (click)="updateColorLabel(null); menu.close()"
          icon="tag-dotted"
          [iconColor]="'gray'"
          [weight]="null === asset.color_label ? 'bold' : ''"
          [fullWidth]="true"
        >
          <span class="{{ null === asset.color_label ? 'text-color-gray' : '' }}">{{ 'not-labeled' | translate }}</span>
        </app-button-menu-item>
      </div>
    </div>
  </app-context-menu>

  <!-- Comments -->
  <button
    appButton
    name="toggle-comments"
    location="asset-page-footer"
    (click)="toggleSideMenu()"
    [appTooltip]="'comments' | translate"
    tooltipKeyboardShortcut="C"
    [iconButton]="display.comment === 'small'"
    [hasIcon]="display.comment === 'full'"
    data-test-id="comments-button"
    *ngIf="display.comment"
    height="1"
    color="dark-blur"
    size="1"
    weight="bold"
  >
    <app-svg src="/assets/icons/comment-dots.svg"></app-svg>
    <span *ngIf="display.comment === 'full'">
      <span>{{ 'comment' | translate }}</span>
      <span *ngIf="commentCount"> ({{ commentCount > 99 ? '99+' : commentCount }})</span>
    </span>
  </button>

  <!-- Annotations -->
  <ng-container *ngIf="display.annotation">
    <button
      appButton
      name="annotation"
      location="asset-page-footer"
      (click)="onStartAnnotation.emit()"
      [appTooltip]="'annotate-tooltip' | translate"
      tooltipKeyboardShortcut="D"
      [iconButton]="display.annotation === 'small'"
      [hasIcon]="display.annotation === 'full'"
      data-test-id="annotation-button"
      *ngIf="asset.type !== 'video' || featureFlags.get('commentPlacement')"
      height="1"
      color="dark-blur"
      size="1"
      weight="bold"
    >
      <app-svg src="/assets/icons/annotation.svg"></app-svg>
      <span *ngIf="display.annotation === 'full'">
        <span>{{ 'annotate' | translate }}</span>
      </span>
    </button>

    <button
      appButton
      name="DONTREPORT"
      location="asset-page-footer"
      class="fake-disabled"
      [appTooltip]="'Coming Soon'"
      [iconButton]="display.annotation === 'small'"
      [hasIcon]="display.annotation === 'full'"
      *ngIf="asset.type === 'video' && !featureFlags.get('commentPlacement')"
      height="1"
      color="dark-blur"
      size="1"
      weight="bold"
    >
      <app-svg src="/assets/icons/annotation.svg"></app-svg>
      <span *ngIf="display.annotation === 'full'">
        <span>{{ 'annotate' | translate }}</span>
      </span>
    </button>
  </ng-container>

  <button
    appButton
    name="disabled-{{ item.option }}"
    location="asset-page-footer"
    [iconButton]="true"
    color="darker-blur"
    height="1"
    (click)="openReviewSettings()"
    [appTooltip]="'disabled-feature' | translate : [{ key: 'NAME', value: (item.name | translate) }]"
    *ngFor="let item of disabledFeedbackItems"
  >
    <app-svg src="/assets/icons/{{ item.icon }}.svg"></app-svg>
  </button>

  <button
    appButton
    name="review-settings"
    location="asset-page-footer"
    [iconButton]="true"
    color="hard-simple"
    height="1"
    (click)="openReviewSettings()"
    [appTooltip]="'review-settings' | translate"
    *ngIf="accessLevel === 'edit'"
  >
    <app-svg src="/assets/icons/gear.svg"></app-svg>
  </button>
</div>
